import React from "react";

export default function MentionsLegales() {
  return (
    <section className="bg-white py-14 lg:py-20 px-6 lg:px-10" data-testid="legal-mentions">
      <div className="max-w-3xl mx-auto">
        <p className="text-fegreen font-medium uppercase tracking-[0.25em] text-xs mb-3">— Informations légales</p>
        <h1 className="text-3xl lg:text-5xl font-bold text-fegray-dark mb-10">Mentions légales</h1>

        <div className="prose prose-sm lg:prose-base max-w-none text-fegray space-y-8">
          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Éditeur du site</h2>
            <p>
              <strong>FORM'ELEC</strong> — Entreprise individuelle de services à la personne<br />
              Représentée par <strong>Rosalie Riveti</strong>, coach sportive diplômée
            </p>
            <ul className="list-disc pl-5 mt-3 space-y-1">
              <li>Adresse : Istres, Bouches-du-Rhône (13)</li>
              <li>Téléphone : 07 66 25 31 43</li>
              <li>Email : rosariveti@gmail.com</li>
              <li>SIRET : à compléter</li>
              <li>N° agrément Services à la Personne URSSAF : à compléter</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Directrice de la publication</h2>
            <p>Rosalie Riveti — rosariveti@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Hébergement</h2>
            <p>
              Site hébergé via la plateforme <strong>DigiPilote</strong><br />
              Infrastructure cloud sécurisée — données stockées sur serveurs situés dans l'Union Européenne.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus présents sur ce site (textes, images, logos, vidéos)
              est la propriété exclusive de FORM'ELEC, sauf mention contraire. Toute reproduction
              ou diffusion sans autorisation préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Crédits photos &amp; vidéos</h2>
            <p>
              Photos et vidéos : FORM'ELEC, MIHA BODYTEC, Pexels, banque d'images partenaires.
              Logos : Services à la Personne (gouv.fr), MIHA BODYTEC.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Médiation à la consommation</h2>
            <p>
              Conformément à l'article L612-1 du Code de la consommation, le consommateur a la
              possibilité de saisir gratuitement un médiateur de la consommation en cas de litige
              non résolu : <a href="https://www.economie.gouv.fr/mediation-conso" target="_blank" rel="noreferrer" className="text-fegreen font-semibold underline">economie.gouv.fr/mediation-conso</a>.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
}
